import { IRouteMeta } from 'routes/route.interface'

export interface IBackOfficeUserDetailCardProps {
  children: JSX.Element
  meta: IRouteMeta
}

export type TUserComponentsDialogType =
  | 'isApproveDialogOpen'
  | 'isRejectDialogOpen'
  | 'isConfirmationDialogOpen'
  | 'isChangeRoleDialogOpen'

export enum USER_DETAIL_DIALOG_TYPE {
  SEE_USER = 'SEE_USER',
  CHANGE_USER_DATA_DETAIL = 'CHANGE_USER_DATA_DETAIL',
  APPROVE_USER = 'APPROVE_USER',
  REJECT_USER = 'REJECT_USER',
  REMOVE_USER = 'REMOVE_USER',
  CHANGE_ACCOUNT_STATUS = 'CHANGE_ACCOUNT_STATUS',
  CHANGE_USER_ROLE = 'CHANGE_USER_ROLE'
}

export type TUserDetailDialog = USER_DETAIL_DIALOG_TYPE | ''